import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import { useLanguage } from "@/context/LanguageContext";

const inputClass =
  "w-full border border-slate-300 px-3 py-2.5 text-sm rounded-sm focus:border-slate-900 focus:outline-none bg-white text-slate-900";

export default function Login() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      sessionStorage.setItem("lidlink-token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail && typeof err.response.data.detail === "string"
        ? err.response.data.detail
        : t.login.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white flex flex-col" data-testid="login-page">
      <div className="p-6">
        <Link to="/" data-testid="login-logo" className="flex items-center w-fit">
          <Logo dark markClass="w-6 h-6 text-blue-500" textClass="text-lg" />
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-20">
        <div className="w-full max-w-sm bg-slate-900 border border-slate-800 p-8 rounded-sm">
          <h1 className="text-xl font-bold">{t.login.title}</h1>
          <p className="text-xs text-slate-400 mt-1 mb-6 font-mono-spec">{t.login.sub}</p>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="block text-xs font-mono-spec text-slate-400 mb-1">{t.login.email}</label>
              <input
                data-testid="login-email"
                type="email"
                className={inputClass + " !bg-slate-950 !border-slate-800 !text-white"}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="block text-xs font-mono-spec text-slate-400 mb-1">{t.login.password}</label>
              <input
                data-testid="login-password"
                type="password"
                className={inputClass + " !bg-slate-950 !border-slate-800 !text-white"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && (
              <p className="text-xs text-red-400 font-mono-spec" data-testid="login-error">{error}</p>
            )}
            <button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-mono-spec text-xs font-bold rounded-full uppercase tracking-wider transition-colors disabled:opacity-50"
            >
              {t.login.submit}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
